<template>
  <div class="bg-white resumeStyler document" :class="resumeThemeName">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, watch, toRefs } from 'vue'
import { useStyledResume } from '@/composables/useStyledResume'

export default defineComponent({
  name: 'StyleWrapper',
  props: {
    resume: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup(props) {
    const { resume } = toRefs(props)

    const { resumeThemeName, colors, font, setResume, margin, lineHeight } =
      useStyledResume()

    watch(
      resume,
      resume => {
        setResume(resume)
      },
      { immediate: true }
    )

    return { resumeThemeName, margin, lineHeight, colors, font }
  },
})
</script>

<style lang="postcss" scoped>
.resumeStyler {
  --resume-primary-color: v-bind('colors.primaryColor');
  --resume-background-color: v-bind('colors.backgroundColor');
  --resume-background-color-dark: v-bind('colors.backgroundColorDark');
  --resume-font-color: v-bind('colors.fontColor');
  --resume-font-family: v-bind('font.fontFamily');
  --resume-margin: v-bind(margin);
  --resume-line-height: v-bind(lineHeight);
}

@media print {
  .resumeStyler {
    --resume-margin: calc(v-bind(margin) - 2em);
  }
}

:deep(.editable) {
  @apply outline-primary outline-offset-4 outline-2 rounded-sm;
  &:focus {
    @apply z-50;
  }
}
</style>
